import { darkModeState } from "atoms/theme";
import Moon from "components/Icons/Moon";
import Sun from "components/Icons/Sun";
import { useRecoilState } from "recoil";

const DarkModeToggler: React.FC = () => {
  const [darkMode, setDarkMode] = useRecoilState(darkModeState);

  const handleDarkModeChange = () => {
    setDarkMode((currDarkMode) => !currDarkMode);
  };

  return (
    <div className="cursor-pointer inline-block" onClick={handleDarkModeChange}>
      {darkMode ? <Sun /> : <Moon />}
    </div>
  );
};

export default DarkModeToggler;
